/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * Filter Dialog
 * 
 * In diesem Modal-Dialog kann der Benutzer Schlagwörter auswählen. Anhand dieser Auswahl
 * werden dann die Produkte aus dem Produktkatalog gefiltert, die das entsprechende 
 * Schlagwort besitzen.
 * 
 * Wichtig ist hier, dass nicht die globalen tagSettings als mögliche Schlagwörter
 * zur Auswahl gestellt werden, sondern die Schlagwörter, die in der globalen 'tagList'
 * enthalten sind.
 * 
 * Die tagList-Auswahl enthält im Gegensatz zur tagSettings-Auswahl nur die Schlagwörter, 
 * die auch tatsächlich mindestens einmal einem Produkt zugeordnet wurde.
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Icon } from '../../partials/Icons';
import * as appActions from "../../../store/actions/appActions";
import * as utils from "../../../basics/utils";
import * as cordova from "../../../basics/cordova";

class FilterModal extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { windowHeight, unitHeight, toolbarHeight, filterVisible, filterList, tagList, currentContainer } = this.props.app;

        if (!tagList['theme']) return null;
        if (!tagList['product']) return null;

        const height = windowHeight - (unitHeight * 2) - toolbarHeight;
        const itemHeight = unitHeight;

        const onClose = () => {
            this.props.setFilterVisible(false);
        }

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================
        const renderItem = (d, i) => {
            const styleSelected = { backgroundColor: 'rgb(58, 133, 247)', color: 'white' };
            const styleStandard = { backgroundColor: 'rgb( 64, 66,  65)', color: 'white' };

            const style = Object.assign((utils.checkFilter(d)) ? styleSelected : styleStandard, utils.getStyleHeight(itemHeight, .45, .32, .25));

            const onClick = () => {
                let newFilterList = filterList;
                if (utils.checkFilter(d)) { // löschen
                    newFilterList = filterList.filter(value => value !== d)
                } else { // neu anlegen
                    newFilterList.push(d)
                }
                this.props.setFilterList(newFilterList);
                cordova.writeLocalJSON(currentContainer, 'filter.json', newFilterList);
            }

            return (
                <div key={i} className="inline-block bg-gray-200 rounded px-3 py-1 mr-2 mb-2 whitespace-no-wrap overflow-hidden"
                    style={style} onClick={onClick}>{d}
                </div>
            )
        }

        const renderCloseButton = () => {
            return (
                <button className="inline-flex items-top focus:outline-none" onClick={onClose}>
                    <Icon color={'white'} type='close2' width={40} height={40} />
                </button>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        const style = {
            top: (unitHeight * 2) + 'px',
            height: height + 'px',
            minHeight: height + 'px',
            transition: 'all 0.25s'
        }

        if (!filterVisible) return null;

        const styleTitle = utils.getStyleHeight(itemHeight, 1.0, 1.0, 0.5);

        return (
            <div className="Filter absolute w-full flex z-50" style={style} >
                <div className="w-1/2 h-full flex" onClick={onClose}></div>
                <div className="w-1/2 h-full flex flex-col bg-gray-900 relative" >
                    <div className="absolute w-full h-8 flex flex-row-reverse bottom-0 top-0">
                        {renderCloseButton()}
                    </div>
                    <div className="w-full flex flex-col text-white px-4 py-4 overflow-y-auto overflow-x-hidden">
                        <div className="w-full text-left font-semibold" style={styleTitle}>Themenauswahl</div>
                        <div>{tagList.theme.map((d, i) => renderItem(d, i))}</div>
                        <div className="w-full text-left font-semibold" style={styleTitle}>Produktauswahl</div>
                        <div>{tagList.product.map((d, i) => renderItem(d, i))}</div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterModal);
